/**
 * @fileoverview Review & Analysis Phase — parent route
 *
 * Purpose: Layout shell for Phase 3 (Review & Analysis). Renders an
 * `<Outlet />` so the nested sub-routes (`review/index`, `review/$agent`)
 * can mount their own page content.
 *
 * URL: /dashboard/jobs/:jobId/review
 */

import { createFileRoute, Outlet } from "@tanstack/react-router";

export const Route = createFileRoute(
  "/_app/_auth/dashboard/_layout/jobs/$jobId/review",
)({
  component: ReviewPhase,
});

function ReviewPhase() {
  return <Outlet />;
}
